const MarketingHelpers = {
    urls: {
        // TODO: temp solution until we have a pretty about page
        about: () => '/profiles/dep',
        blog: () => '/blog',
        docs: () => '/docs',
        news: () => '/blog?category=News',
        updates: () => '/blog?category=Updates',
        tutorials: () => '/blog?category=Tutorial',
        dcide: {
            overview: () => '/design-software',
            pricing: (hash?: string) => `/design-software/pricing${hash ? `#${hash}` : ''}`,
            expertSupport: () => '/design-software#expert-support',
            contact: () => '/design-software/contact',
        },
        controller: {
            overview: () => '/controller',
            intelligentEnergyControl: () => '/controller/intelligent-energy-control',
            customApplicationDevelopment: () => '/controller/custom-application-development',
            coreIntegrationFeatures: () => '/controller/core-integration-features',
            caseStudies: () => '/controller/case-studies',
            starterKit: () => '/controller/starter-kit',
            pricing: () => '/controller/pricing',
            documentation: () => 'https://docs.directenergypartners.com',
            pricingConfigurator: () => '/controller/pricing/configurator',
            contact: () => '/controller/contact',
            faq: () => '/controller/faq',
            partnerProgram: () => '/controller/partner-program',
        },
        licenseAgreement: () => '/license-agreement',
        resourcepro: {
            overview: () => '/resourcepro',
            dashboard: () => '/resourcepro/dashboard',
            joinAsPro: () => '/resourcepro/join-as-pro',
            qrCodes: () => '/resourcepro/qr-codes',
            faq: () => '/resourcepro/faq',
            mediaToolkit: () => '/resourcepro/media-toolkit',
            pricing: () => '/resourcepro/pricing',
            resources: () => '/resourcepro/resources',
        },
    },
};

export { MarketingHelpers };
